import type { IAiAgentSessionService } from "@/application/ports/services/IAiAgentSessionService";
import type { IStorageService } from "@/application/ports/services";
import { SESSION_STORAGE_KEYS } from "./constants";

export class AiAgentSessionService implements IAiAgentSessionService {
  constructor(private storageService: IStorageService) {}

  getSessionId(): string | null {
    return this.storageService.get<string>(SESSION_STORAGE_KEYS.AI_AGENT_SESSION_ID);
  }

  setSessionId(id: string): void {
    this.storageService.set(SESSION_STORAGE_KEYS.AI_AGENT_SESSION_ID, id);
  }

  clearSession(): void {
    this.storageService.remove(SESSION_STORAGE_KEYS.AI_AGENT_SESSION_ID);
  }
}
